<template>
    <div
        class="overzichtonderbetalen floatleft width30 marginright20 paddingright20 borderright1"
        id="overzichtonderbetalen-offerte"
    >
        <div class="overiginfo width100 floatleft">
            <div
                class="block nopadding round5 marginleft10 margintop10 noborder"
            >
                <span class="bold">De zekerheid van CruiseReizen.nl</span>
                <ul class="checks marginleft5 nofloat">
                    <li><strong>Geen</strong> verborgen kosten</li>
                    <li>
                        <a
                            href="/laagsteprijsgarantie"
                            style="color:#333333;text-decoration:underline;"
                        >
                            Laagsteprijsgarantie
                        </a>
                    </li>
                    <li><b>7 dagen</b> p/w geopend</li>
                    <li>
                        Je eigen contactpersoon
                    </li>
                    <li>Klantbeoordeling <b>9.8/10</b></li>
                    <li><b>45.506</b> vind-ik-leuks</li>
                    <li><b>ANVR</b>, <b>SGR</b> en <b>CLIA</b> lid</li>
                </ul>
            </div>
            <div class="clear"></div>
            <div class="overiglogos margintop10">
                <ul class="logos-img nolist">
                    <li>
                        <a
                            href="/anvr-algemene-nederlandse-vereniging-voor-reisondernemingen"
                        >
                            <span class="anvr-img" />
                        </a>
                    </li>
                    <li>
                        <a href="/sgr-stichting-garantiefonds-reisgelden">
                            <span class="sgr-img" />
                        </a>
                    </li>
                    <li>
                        <a
                            href="/calamiteitenfonds-stichting-calamiteitenfonds-reizen"
                        >
                            <span class="cal-img" />
                        </a>
                    </li>
                    <li>
                        <span class="clia-img"></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'USPSVertical',
}
</script>

<style scoped></style>
